var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInvert = function SvgInvert(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invert",
    transform: "translate(-624 -370)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67995",
    "data-name": "Group 67995",
    transform: "translate(2195.204 -5241.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67996",
    "data-name": "Group 67996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exchange-vertical",
    d: "M-1556.32,5639.828v-24h-2.033v19.1l-7.413-7.406-1.437,1.423,9.867,9.875Zm-1.041-3.908h.047l-.022.024Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39348",
    "data-name": "Path 39348",
    d: "M-1538.686,5615.828v24h2.033v-19.1l7.413,7.407,1.438-1.424-9.867-9.875Z",
    transform: "translate(-14.887)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3140",
    "data-name": "Ellipse 3140",
    transform: "translate(624 370)",
    fill: "none",
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInvert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invert.49973bb9.svg";
export { ForwardRef as ReactComponent };